const huffman = [[[[["w","u"],[["8",["y",["5",["j"]]]],"h"]],["s",[["2","n"],"x"]]],[[["c",["k","f"]],"b"],[["t","m"],["9","7"]]]],[" ",[[[["e","d"],"p"],["g",[[["z","q"],"3"],["v","6"]]]],[["r","l"],["a",[["1",["4","0"]],["i","o"]]]]]]];

export default class BinaryReader {
  bitpos = 0;
  constructor(buffer) {
    this.buffer = buffer;
  }

  // aligned, does not check
  read8() {
    const value = this.buffer[this.bitpos >> 3];
    this.bitpos += 8;
    return value;
  }
  read16() {
    const idx = this.bitpos >> 3;
    const value1 = this.buffer[idx];
    const value2 = this.buffer[idx + 1];
    this.bitpos += 16;
    return value1 | (value2 << 8);
  }
  read32() {
    const idx = this.bitpos >> 3;
    const value1 = this.buffer[idx];
    const value2 = this.buffer[idx + 1];
    const value3 = this.buffer[idx + 2];
    const value4 = this.buffer[idx + 3];
    this.bitpos += 32;
    return (value1 | (value2 << 8) | (value3 << 16) | (value4 << 24)) >>> 0;
  }
  byte(offset) {
    return this.buffer[(this.bitpos >> 3) + offset];
  }
  string(length) {
    const end = (this.bitpos >> 3) + length;
    let index = this.buffer.indexOf(0, this.bitpos >> 3);
    if (index < 0) index = length;
    else index = Math.min(index, end);
    const result = String.fromCharCode(...this.buffer.subarray(this.bitpos >> 3, index));
    this.bitpos = end << 3;
    return result;
  }

  seek(pos) {
    this.bitpos = pos << 3;
  }
  skip(bytes) {
    this.bitpos += bytes << 3;
  }

  align() {
    this.bitpos = (this.bitpos + 7) & (~7);
  }

  bits(count) {
    let result = 0;
    let shift = 0;
    while (count) {
      const byte = this.bitpos >> 3;
      const bit = this.bitpos & 7;
      const read = Math.min(count, 8 - bit);
      const value = (this.buffer[byte] >> bit) & ((1 << read) - 1);
      result |= value << shift;
      shift += read;
      count -= read;
      this.bitpos += read;
    }
    return result;
  }
  bit() {
    const result = (this.buffer[this.bitpos >> 3] >> (this.bitpos & 7)) & 1;
    this.bitpos += 1;
    return result;
  }
  skipbits(count) {
    this.bitpos += count;
  }

  char() {
    let node = huffman;
    while (Array.isArray(node)) {
      node = node[this.bit()];
    }
    return node;
  }
  
  eof() {
    return this.bitpos === this.buffer.byteLength * 8;
  }
}
